import ARRAY_INCLUDES from "./array_includes";
import ARRAY_INCLUDES_NOT from "./array_includes_not";

export default {
  ARRAY_INCLUDES,
  ARRAY_INCLUDES_NOT,
};
